// components/Spinner/Spinner.jsx
import React from 'react';
import './Spinner.css';

/**
 * Spinner componente reutilizable para estados de loading
 * 
 * @param {Object} props
 * @param {string} props.size - Tamaño: 'xs' | 'sm' | 'md' | 'lg' | 'xl' (default: 'md')
 * @param {string} props.color - Color del spinner: 'primary' | 'white' | 'purple' | 'green' | 'blue' (default: 'primary')
 * @param {string} props.className - Clases adicionales
 * @param {string} props.label - Texto opcional junto al spinner
 * @param {boolean} props.center - Si debe centrarse en su contenedor (default: false)
 * @param {boolean} props.fullScreen - Si debe ocupar toda la pantalla (default: false)
 */
const Spinner = ({ 
  size = 'md', 
  color = 'primary',
  className = '',
  label = '',
  center = false,
  fullScreen = false
}) => {
  const sizeClasses = {
    xs: 'spinner-xs',
    sm: 'spinner-sm',
    md: 'spinner-md',
    lg: 'spinner-lg',
    xl: 'spinner-xl'
  };

  const colorClasses = {
    primary: 'spinner-primary',
    white: 'spinner-white',
    purple: 'spinner-purple',
    green: 'spinner-green',
    blue: 'spinner-blue',
    yellow: 'spinner-yellow'
  };

  const spinnerElement = (
    <div 
      className={`spinner ${sizeClasses[size] || sizeClasses.md} ${colorClasses[color] || colorClasses.primary} ${className}`}
      role="status"
      aria-label={label || 'Loading'}
    >
      <span className="spinner-sr-only">{label || 'Loading...'}</span>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="spinner-fullscreen">
        <div className="spinner-fullscreen-content">
          {spinnerElement}
          {label && <span className="spinner-label">{label}</span>}
        </div>
      </div>
    );
  }

  if (center) {
    return (
      <div className="spinner-center">
        {spinnerElement}
        {label && <span className="spinner-label">{label}</span>}
      </div>
    );
  }

  if (label) {
    return (
      <div className="spinner-with-label">
        {spinnerElement}
        <span className="spinner-label">{label}</span>
      </div>
    );
  }

  return spinnerElement;
};

export default Spinner;
